/* Hairecover: one helper to refresh + open the theme cart drawer after any custom add-to-cart. */
(function () {
  if (window.hcOpenCartDrawer) return;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var onCartPage = function () { return /\/cart\/?$/.test(location.pathname); };

  window.hcOpenCartDrawer = async function (addResponse) {
    try { sessionStorage.setItem('hcPromoShown', '1'); } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (onCartPage() || !drawer || typeof drawer.renderContents !== 'function') {
      if (onCartPage()) location.reload(); else location.assign(root() + 'cart');
      return false;
    }
    var data = addResponse && addResponse.sections && addResponse.sections['cart-drawer'] ? addResponse : null;
    if (!data) {
      var res = await fetch(root() + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
      if (!res.ok) { location.assign(root() + 'cart'); return false; }
      data = { sections: await res.json() };
    }
    try {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (e) {
      location.assign(root() + 'cart');
      return false;
    }
    // Icon bubble (in case renderContents did not update it)
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      var fresh = doc.querySelector('.shopify-section') || doc.body;
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
    if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
    return true;
  };

  // Shared add: items -> /cart/add.js with drawer sections, then open. Throws Error(message) on failure.
  window.hcAddToCart = async function (items) {
    var res = await fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
    await window.hcOpenCartDrawer(data);
    return data;
  };
})();

/* Hairecover: removing a main product also removes the free gift(s) (_gift) linked to it.
   Liquid puts data-hc-key / data-hc-gift-keys on cart-remove-button (blocks/cart-drawer_items, sections/main-cart-items). */
(function () {
  if (window.hcGiftRemoveInit) return;
  window.hcGiftRemoveInit = true;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('cart-remove-button[data-hc-gift-keys]');
    if (!btn) return;
    var keys = (btn.dataset.hcGiftKeys || '').split(',').filter(Boolean);
    if (!keys.length || !btn.dataset.hcKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var row = btn.closest('.cart-item');
    if (row) { row.style.opacity = '.5'; row.style.pointerEvents = 'none'; }
    var updates = {};
    updates[btn.dataset.hcKey] = 0;
    keys.forEach(function (k) { updates[k] = 0; });
    var onCart = /\/cart\/?$/.test(location.pathname);
    try {
      var res = await fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw new Error('update failed');
      if (onCart) { location.reload(); return; }
      var drawer = document.querySelector('cart-drawer');
      if (data.item_count === 0 && drawer) drawer.classList.add('is-empty');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections['cart-icon-bubble']) {
          var doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      } else {
        location.reload();
      }
    } catch (err) {
      location.reload();
    }
  }, true);
})();
